module.exports = __webpack_public_path__ + "account/assets/close-fixed-btn.0357ded3.svg";